import request from '@/utils/request'
export function userLogin(phone:string, password:string) {
    return request({
      url: 'login',
      method: 'post',
      data: {
        username:phone,
        password,
      }
    })
  }
